const mainRouter = [{
    path: '/',
    name: '首页',
    component: () => import('@/pages/index'),
    meta: {
        title: '感谢您的爱心捐赠'
    }
}, {
    path: '/cert',
    name: '证书',
    component: () => import('@/pages/cert'),
    meta: {
        title: '感谢您的爱心捐赠' 
    }   
}, {
    path: '/query',
    name: '查询',
    component: () => import('@/pages/query'),
    meta: {
        title: '捐款信息查询' ,
        keepAlive: true
    }   
}];

export default mainRouter;


// WEBPACK FOOTER //
// ./src/router/main.js